<!--Stripe Account Onboarding Component For Start Fundraiser Flow-->
<ng-container *ngIf="!this.isPayoutSettingsFlow; else payoutSettingsFlow">
	<div class="flex justify-end pb-6">
		<!-- Stripe will render its form and button here -->
		<div id="container" class="w-full"></div>
	</div>
</ng-container>
<ng-template #payoutSettingsFlow>
	<div class="w-[100%] sm:w-[94%] md:w-[80%] xl:w-[60%] pl-0 pt-6 sm:pl-6 pb-8">
		<div class="flex justify-between items-center pl-6 pr-6 sm:pl-0 md:pr-0">
			<h1
				class="dark-grey-texts reset-spacing"
				i18n="@@title_stripe_verification"
			>
				Stripe Verification
			</h1>
		</div>
		<div
			class="flex flex-col justify-start md:rounded-lg pl-6 pr-6 mt-4 border border-solid border-color gap-1"
		>
			<div class="flex justify-end pb-6">
				<!-- Stripe will render its form and button here -->
				<div id="container" class="w-full"></div>
			</div>
		</div>
	</div>
</ng-template>
